import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { PatientInsurance } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

// Presentational dropdown for choosing among a patient's coverages of one type.
// State (the option list + current pick) is owned by EstimateInsuranceLoader;
// this component only renders and emits the chosen coverage.
@Component({
  selector: 'mmx-balance-insurance-picker',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, TranslateModule],
  templateUrl: './balance-insurance-picker.component.html',
})
export class BalanceInsurancePickerComponent {
  @Input() labelKey = ''
  @Input() options: PatientInsurance[] = []
  @Input() selected: PatientInsurance | null = null
  @Input() disabled = false

  @Output() readonly selectionChange = new EventEmitter<PatientInsurance>()

  compareById(a: PatientInsurance | null, b: PatientInsurance | null): boolean {
    return a?.id === b?.id
  }

  onSelectionChange(insurance: PatientInsurance): void {
    this.selectionChange.emit(insurance)
  }
}
